import { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import TenantService from '../../../../services/tenant_service';
import { useTenant } from '../../../../hooks/useTenant';

export const useCompanySettings = () => {
    const { idTenant, user } = useTenant();
    const [initialData, setInitialData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        const fetchCompanyData = async () => {
            if (!idTenant) return;
            try {
                const data = await TenantService.getTenantInfo(idTenant);
                // Ensure nested object exists to prevent formik errors
                if (!data.legalRepresentative) {
                    data.legalRepresentative = { name: '', cpf: '', email: '', phone: '' };
                }
                if (!data.technicalCoordinator) {
                    data.technicalCoordinator = { firstName: '', lastName: '', photoUrl: '', email: '', phone: '' };
                }
                setInitialData(data);
            } catch (error) {
                console.error("Erro ao carregar dados da empresa:", error);
                toast.error("Erro ao carregar configurações da empresa.");
            } finally {
                setLoading(false);
            }
        };

        fetchCompanyData();
    }, [idTenant]);

    const handleSubmit = async (values) => {
        setSaving(true);
        try {
            const payload = {
                ...values,
                id: idTenant
            };
            await TenantService.updateTenantInfo(payload, user);
            
            toast.success("Dados da empresa atualizados com sucesso!");
        } catch (error) {
            console.error("Erro ao atualizar empresa:", error);
            toast.error("Falha ao salvar as configurações.");
        } finally {
            setSaving(false);
        }
    };

    return {
        data: initialData,
        loading,
        saving,
        actions: {
            handleSubmit
        }
    };
};
